export default __webpack_public_path__ + "static/media/curse-of-the-cyberons.9238c957.jpg";